import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import * as toDoActions from '../../features/todos/actions';
import * as toDoSelectors from '../../features/todos/selectors';
import { IRouteTrackModel } from '../models/route-track.model';
import { SharedService } from '../../shared/shared.service';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbRoutesControlService implements OnDestroy {
  subscription: Subscription = new Subscription();
  previousUrl: string;
  collectedRoutes: IRouteTrackModel[] = [];
  routesFromStore: IRouteTrackModel[];

  constructor(
    private router: Router,
    private store: Store,
    public sharedService: SharedService
  ) {
    this.subscription.add(
      this.store.select(toDoSelectors.getRouteTracked).subscribe(loci => {
        if (loci !== undefined) {
          this.collectedRoutes = loci;
        }
      })
    );

    this.subscription.add(
      this.router.events.subscribe((evt: any) => {
        if (evt instanceof NavigationEnd) {
          switch (evt.url) {
            case '/todo':
              this.detectCopyRouteControl('To Do', evt.url, true);
              break;
            case '/settings':
              this.detectCopyRouteControl('Settings', evt.url, false);
              break;
            case '/search':
              this.detectCopyRouteControl('Global Search', evt.url, false);
              break;
            case '/employee/employee-details':
              var userTitle = this.sharedService.isLegalEntityTypeBusiness ? 'Member Details' : 'User Details';
              this.detectCopyRouteControl(userTitle, evt.url, false);
              break;
            case '/product-detail':
              this.detectCopyRouteControl('Product Details', evt.url, false);
              break;
            case '/legal-entities':
              this.detectCopyRouteControl('Legal Entities', evt.url, false);
              break;
            case '/legal-entity-setup':
              this.detectCopyRouteControl('Legal Entities Setup', evt.url, false);
              break;
            case '/legal-entities/offerings':
              this.detectCopyRouteControl('Products and investment solutions', evt.url, false);
              break;
            case '/legal-entities/manage-products':
              this.detectCopyRouteControl('Investment Solutions', evt.url, false);
              break;
            case '/manage-employees':
              this.detectCopyRouteControl('Manage Members', evt.url, false);
              break;
            case '/legal-entities/user-analytics':
              this.detectCopyRouteControl('User Analytics', evt.url, false);
              break;
            case '/member-onboard':
              this.detectCopyRouteControl('User Onboard', evt.url, false);
              break;
            case '/employee-group-setup':
              this.detectCopyRouteControl('Users Group Setup', evt.url, false);
              break;
            case '/products':
              this.detectCopyRouteControl('Products', evt.url, false);
              break;
            case '/payment-runs':
              this.detectCopyRouteControl('Payment Runs', evt.url, false);
              break;
            case '/product-solutions':
              this.detectCopyRouteControl('Investment Solutions', evt.url, false);
              break;
            case '/product-solutions/editSolution':
              this.detectCopyRouteControl('Edit Solution', evt.url, false);
              break;
            case '/product-solutions/addSolution':
              this.detectCopyRouteControl('Add Solution', evt.url, false);
              break;
            case '/reports':
              this.detectCopyRouteControl('Reports', evt.url, false);
              break;
            case '/broadcast':
              this.detectCopyRouteControl('Broadcast', evt.url, false);
              break;
            case '/exclude-dma-accounts':
              this.detectCopyRouteControl('Update DMA Account values', evt.url, false);
              break;
            case '/legal-entities/pfsettings':
              this.detectCopyRouteControl('PF Settings', evt.url, false);
              break;
            case '/manage-employees':
              this.detectCopyRouteControl('Manage Members', evt.url, false);
              break;
            case '/manage-users':
              this.detectCopyRouteControl('Manage Users', evt.url, false);
              break;
            case '/manage-products':
              this.detectCopyRouteControl('Manage Products', evt.url, false);
              break;
            case '/product-configuration':
              this.detectCopyRouteControl('Manage Products', evt.url, false);
              break;
            case '/manage-products/add-product':
              this.detectCopyRouteControl('Product Form', evt.url, false);
              break;
            case '/manage-products/add-product-configuration':
              this.detectCopyRouteControl('Add Product Configuration', evt.url, false);
              break;
            case '/roles':
              this.detectCopyRouteControl('Roles', evt.url, false);
              break;
            case '/entity-dashboard':
              this.detectCopyRouteControl('Legal Entity Dashboard', evt.url, false);
              break;
            case '/admin-dashboard':
              this.detectCopyRouteControl('Admin Dashboard', evt.url, true);
              break;
            case '/entity-admin-dashboard':
              this.detectCopyRouteControl('Admin Dashboard', evt.url, false);
              break;
            default:
              if (evt.url.startsWith('/manage-users/entities/')) {
                this.detectCopyRouteControl('User Entities', evt.url, false);
              } else if (evt.url.startsWith('/manage-products/edit-product-configuration')) {
                this.detectCopyRouteControl('Edit Product Configuration', evt.url, false);
              }
              break;
          }
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  detectCopyRouteControl(routeName: string, url: string, isToDo) {
    let newArr = [];
    newArr = [...this.collectedRoutes];

    if (newArr.length > 0 && newArr.some(u => u.tracker === url)) {
      newArr.forEach((r, i) => {
        if (r.tracker === url) {
          newArr.length = i === 0 ? (newArr.length = 1) : (newArr.length = i + 1);
        }
        this.collectedRoutes = [...newArr];
      });
    } else {
      const routeObj: IRouteTrackModel = {
        label: routeName,
        tracker: url
      };
      newArr.push(routeObj);
      this.collectedRoutes = newArr;
    }
    this.saveRouteToStore(this.collectedRoutes, isToDo);
  }

  saveRouteToStore(routeObj: IRouteTrackModel[], isToDo: boolean) {
    let observeRoutes: IRouteTrackModel[] = [];
    if (isToDo) {
      observeRoutes = [{ label: 'Admin Dashboard', tracker: '/admin-dashboard' }];
    } else {
      observeRoutes = routeObj;
    }
    this.store.dispatch(toDoActions.loadTrackRoutes({ routes: observeRoutes }));
  }
}
